// packages/shared/src/components/timeTracking/timeEntryPrefill.ts
import { format } from 'date-fns';

export interface TimerPrefill {
  dossierId: string;
  taskId: string | null;
  startedAt: string;        // ISO
  durationMinutes: number;
}

export interface PrefillFormValues {
  date: string;            // YYYY-MM-DD
  startTime: string;       // HH:mm
  durationText: string;
  is_billable: boolean;
  billing_code: string;
  description: string;
}

export function prefillToFormValues(p: TimerPrefill): PrefillFormValues {
  const start = new Date(p.startedAt);
  return {
    date: format(start, 'yyyy-MM-dd'),
    startTime: format(start, 'HH:mm'),
    durationText: String(p.durationMinutes),
    is_billable: true,
    billing_code: '',
    description: '',
  };
}
